"use client";

import React from 'react';
import GradientLogo from '@/components/ui/GradientLogo';

interface BrandedSpinnerProps {
  /** Size of the spinner */
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /** Additional CSS classes */
  className?: string;
  /** Whether to use the brand gradient */
  useGradient?: boolean;
}

/**
 * Branded CheerVue loading spinner using the logo badge
 */
export default function BrandedSpinner({
  size = 'md',
  className = '',
  useGradient = true,
}: BrandedSpinnerProps) {
  const sizeMap = {
    sm: 24,
    md: 48,
    lg: 64,
    xl: 96,
  };

  const pixelSize = sizeMap[size];

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="relative flex items-center justify-center">
        {/* Outer rotating branded circle */}
        <div 
          className="absolute animate-spin rounded-full border-2 border-transparent border-t-brand-500 border-r-brand-500/30"
          style={{ 
            width: pixelSize + 12, 
            height: pixelSize + 12,
            animationDuration: '1.5s'
          }}
        />
        
        {/* Inner pulsing logo badge */}
        <div className="animate-pulse">
          <GradientLogo 
            variant="badge" 
            width={pixelSize} 
            height={pixelSize} 
            useGradient={useGradient}
          />
        </div>
      </div>
    </div>
  );
}


